import { logUsage } from 'owa-analytics';
import { userDate } from 'owa-datetime';
import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';
import { ODBSharingInfo, refreshExpirationDate } from 'owa-sharing-data';
import { isNullOrWhiteSpace } from 'owa-string-utils';
import { orchestrator } from 'satcheljs';
import { setRefreshStatus, updateSharingLinkUrl } from '../actions/internalActions';
import getSharingLinkInfo from '../selectors/getSharingLinkInfo';
import { createSharingLink } from '../services/createSharingLink';
import SharingLinkInfo from '../store/schema/SharingLinkInfo';
import { LinkActionStatus } from '../types/LinkActionStatus';

orchestrator(refreshExpirationDate, async actionMessage => {
    if (typeof actionMessage.id === 'string') {
        const sharingLink: SharingLinkInfo = getSharingLinkInfo(<string>actionMessage.id);
        if (sharingLink.providerType !== AttachmentDataProviderType.OneDrivePro) {
            // VSTO: 58779 to see whether we need to enable this for ODC links
            throw new Error('refreshExpirationDate only supports OneDrivePro link.');
        }
        if (!!sharingLink) {
            setRefreshStatus(actionMessage.id, LinkActionStatus.refreshing);
            const newLink = await createSharingLink(
                (<ODBSharingInfo>sharingLink.sharingInfo).canonicalUrl,
                sharingLink.permissionLevel
            );
            if (isNullOrWhiteSpace(newLink.Link)) {
                setRefreshStatus(actionMessage.id, LinkActionStatus.refreshFailed);
                logUsage('LinkRefreshLinkFailed');
                return;
            }
            setRefreshStatus(actionMessage.id, LinkActionStatus.refreshSucceeded);
            updateSharingLinkUrl(
                sharingLink.linkId,
                newLink.Link,
                sharingLink.url,
                newLink.ExpirationDate ? userDate(newLink.ExpirationDate) : null
            );
        }
    }
});
